var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "3 5 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9672 13.4326L10.8084 15.6663C11.0356 15.6663 11.134 15.5687 11.252 15.4515L12.3172 14.4334L14.5244 16.0499C14.9293 16.2755 15.2145 16.1567 15.3237 15.6775L16.7725 8.88849L16.7729 8.88809C16.9013 8.28968 16.5565 8.05567 16.1621 8.20248L7.64588 11.463C7.06466 11.6886 7.07346 12.0126 7.54707 12.1594L9.72433 12.8366L14.7816 9.67211C15.0197 9.51451 15.2361 9.60171 15.0581 9.75931L10.9672 13.4326Z",
    fill: "#FDF4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8f854946aabb6d031a98527a46f0a16e.svg";
export { ForwardRef as ReactComponent };